export default {
    OFFICE_PEOPLE_CONTAINER: 'office-people-container',
    ML_PEOPLE_CONTAINER: 'ml-people-container',
};